/* PARTLINE — Shopify theme
   Cart is Shopify's AJAX cart. Prices always come from Shopify, never from JS constants. */
(() => {
'use strict';
const $  = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const on = (sel, ev, fn) => { const el = $(sel); if (el) el.addEventListener(ev, fn); };
const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
const CFG = window.PARTLINE || {};
const L = CFG.i18n || {};
const fmt = (str, o) => String(str).replace(/\{(\w+)\}/g, (m, k) => (o && k in o ? o[k] : m));

const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {
  style: 'currency', currency: CFG.currency || 'AUD',
  minimumFractionDigits: cents % 100 === 0 ? 0 : 2
}).format(cents / 100);

/* ---------- drawers ---------- */
let lastFocus = null;
function openDrawer(w) {
  lastFocus = document.activeElement;
  $('#scrim')?.classList.add('on');
  $(w === 'cart' ? '#cartDrawer' : '#navDrawer')?.classList.add('on');
  if (w === 'nav') $('#navBtn')?.setAttribute('aria-expanded', 'true');
  document.body.style.overflow = 'hidden';
}
function closeDrawers() {
  $('#scrim')?.classList.remove('on');
  $('#cartDrawer')?.classList.remove('on'); $('#navDrawer')?.classList.remove('on');
  $('#navBtn')?.setAttribute('aria-expanded', 'false');
  document.body.style.overflow = ''; lastFocus?.focus?.();
}
on('#navBtn', 'click', () => openDrawer('nav'));
on('#cartBtn', 'click', () => { renderCart(); openDrawer('cart'); });
on('#scrim', 'click', closeDrawers);
$$('[data-close]').forEach(b => b.addEventListener('click', closeDrawers));
document.addEventListener('keydown', e => e.key === 'Escape' && closeDrawers());

/* ---------- marquee pause (WCAG 2.2.2) ---------- */
on('#mqBtn', 'click', e => {
  const p = $('#announce').classList.toggle('paused');
  e.currentTarget.setAttribute('aria-pressed', String(p));
  e.currentTarget.setAttribute('aria-label', p ? L.resume : L.pause);
});

/* ---------- carousels ---------- */
function wireDots(trackSel, dotsSel, label, prevSel, nextSel) {
  const track = $(trackSel), dots = $(dotsSel);
  if (!track || !dots) return;
  const items = () => [...track.children];
  const maxScr = () => Math.max(0, track.scrollWidth - track.clientWidth);
  const step = () => { const it = items(); return it.length < 2 ? (track.clientWidth || 1)
    : Math.abs(it[1].offsetLeft - it[0].offsetLeft) || track.clientWidth || 1; };
  const perView = () => Math.max(1, Math.round(track.clientWidth / step()));
  const pages = () => Math.max(1, Math.ceil(items().length / perView()));
  const cur = () => maxScr() ? Math.round(track.scrollLeft / maxScr() * (pages() - 1)) : 0;
  const target = i => pages() > 1 ? (maxScr() * i) / (pages() - 1) : 0;
  function render() {
    const n = pages(), c = cur();
    dots.style.visibility = n <= 1 ? 'hidden' : '';
    dots.innerHTML = Array.from({ length: n }, (_, i) =>
      `<button type="button" data-i="${i}" aria-current="${i === c}" aria-label="${fmt(L.page_of, { label, i: i + 1, n })}"></button>`).join('');
    $$(dotsSel + ' button').forEach(b => b.addEventListener('click', () =>
      track.scrollTo({ left: target(+b.dataset.i), behavior: RM ? 'auto' : 'smooth' })));
    sync();
  }
  function sync() {
    const c = cur();
    $$(dotsSel + ' button').forEach((b, j) => b.setAttribute('aria-current', String(c === j)));
    if (prevSel) $(prevSel)?.toggleAttribute('disabled', c === 0);
    if (nextSel) $(nextSel)?.toggleAttribute('disabled', c >= pages() - 1);
  }
  let raf;
  track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
  addEventListener('resize', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(render); });
  if (prevSel) $(prevSel)?.addEventListener('click', () => track.scrollTo({ left: target(cur() - 1), behavior: RM ? 'auto' : 'smooth' }));
  if (nextSel) $(nextSel)?.addEventListener('click', () => track.scrollTo({ left: target(cur() + 1), behavior: RM ? 'auto' : 'smooth' }));
  render();
}

/* gallery thumbs mirror the slides */
(function gallery() {
  const track = $('#galTrack'), thumbs = $('#galThumbs');
  if (!track) return;
  if (thumbs) {
    thumbs.innerHTML = [...track.children].map((s, i) =>
      `<button type="button" data-i="${i}" aria-pressed="${i === 0}">${s.innerHTML}</button>`).join('');
    $$('#galThumbs button').forEach(b => b.addEventListener('click', () => {
      const el = track.children[+b.dataset.i];
      if (el) track.scrollTo({ left: el.offsetLeft - track.offsetLeft, behavior: RM ? 'auto' : 'smooth' });
      $$('#galThumbs button').forEach((x, j) => x.setAttribute('aria-pressed', String(+b.dataset.i === j)));
    }));
  }
  wireDots('#galTrack', '#galDots', L.image, '#galPrev', '#galNext');
})();
wireDots('#rvGrid', '#rvDots', L.reviews, '#rvPrev', '#rvNext');
wireDots('#weeksRow', '#weeksDots', L.week);
wireDots('#howGrid', '#howDots', L.step);

/* ---------- tutorial video ---------- */
const tutV = $('#tutVideo'), tutP = $('#tutPlay');
if (tutV && tutP) {
  tutP.addEventListener('click', () => tutV.play());
  tutV.addEventListener('play', () => { tutP.hidden = true; });
  tutV.addEventListener('ended', () => { tutP.hidden = false; tutV.currentTime = 0; });
}

/* ---------- product: variants, tiers, add to cart ---------- */
const form = $('#addForm');
if (form) {
  const variants = JSON.parse($('#variantData')?.textContent || '[]');
  const planData = JSON.parse($('#planData')?.textContent || '{"plans":[],"allocations":{}}');
  // Loop names its plans in WEEKS ("Deliver every 4 weeks"); our packs are in MONTHS.
  // Match on either, so the theme works whichever way the merchant words them.
  const numOf = name => { const n = parseInt((name.match(/\d+/) || [])[0], 10); return Number.isFinite(n) ? n : 1; };
  const subOn = () => $('#tSub')?.getAttribute('aria-pressed') === 'true';
  // the plan whose delivery interval matches the pack the shopper picked
  const planFor = label => {
    const pack = packOf(label);
    const P = planData.plans;
    return P.find(p => /(week|semaine|veck)/i.test(p.name) && numOf(p.name) === pack * 4)
        || P.find(p => /(month|mois|månad)/i.test(p.name) && numOf(p.name) === pack)
        || P[0];
  };
  const allocFor = (variantId, planId) =>
    (planData.allocations[variantId] || []).find(a => a.plan === planId);
  const sel = () => {
    const o = [];
    const shade = $('#shades .sw[aria-pressed="true"]');
    const tier  = $('#tiers .tier[aria-pressed="true"]');
    if (shade) o[+shade.dataset.opt] = shade.dataset.value;
    if (tier)  o[+tier.dataset.opt]  = tier.dataset.value;
    return o;
  };
  const match = opts => variants.find(v => opts.every((val, i) => val == null || v.options[i] === val));
  const current = () => match(sel()) || variants[0];

  /* per-stick maths reads the pack size out of the option label ("2 months" -> 2) */
  const packOf = label => { const n = parseInt(label, 10); return Number.isFinite(n) && n > 0 ? n : 1; };

  const UD = $('#tiers')?.dataset || {};
  function paint() {
    const v = current();
    if (!v) return;
    $('#variantId').value = v.id;

    const plan = planFor(v.options[1] || '1 month');
    const alloc = plan ? allocFor(String(v.id), plan.id) : null;
    const useSub = subOn() && !!alloc;
    if ($('#sellingPlan')) $('#sellingPlan').value = useSub ? plan.id : '';
    if (alloc) {
      const pct = Math.round((1 - alloc.price / v.price) * 100);
      $('#subPct') && ($('#subPct').textContent = pct + '%');
      $('#subNote') && ($('#subNote').textContent = useSub
        ? fmt(L.sub_note, { plan: plan.name.split(' — ')[0], price: money(alloc.price) })
        : L.one_time_note);
    }
    $('#curShade') && ($('#curShade').textContent = v.options[0] || '');

    // cheapest single-month variant of this shade = the honest "was" basis
    const base = variants.find(x => x.options[0] === v.options[0] && packOf(x.options[1] || '1') === 1);

    $$('#tiers .tier').forEach(t => {
      const label = t.dataset.value;
      const tv = match([v.options[0], label]);
      const pack = packOf(label);
      const now = t.querySelector('[data-tier-now]'), was = t.querySelector('[data-tier-was]');
      const per = t.querySelector('[data-tier-per]'), sub = t.querySelector('[data-tier-sub]');
      if (!tv) { t.hidden = true; return; }
      t.hidden = false;
      const tPlan = planFor(label);
      const tAlloc = tPlan ? allocFor(String(tv.id), tPlan.id) : null;
      const shown = (subOn() && tAlloc) ? tAlloc.price : tv.price;
      now && (now.textContent = money(shown));
      per && (per.textContent = fmt(UD.per || L.per_stick, { price: money(Math.round(shown / pack)) }));
      sub && (sub.textContent = 'per' in UD ? (pack === 1 ? UD.unitOne : fmt(UD.unitMany, { n: pack })) : (pack === 1 ? L.one_stick : fmt(L.n_sticks, { n: pack })));
      const cmp = tv.compare_at_price > tv.price ? tv.compare_at_price : 0;
      const full = cmp || ((subOn() && tAlloc) ? tv.price : (base ? base.price * pack : 0));
      if (was) {
        const show = full > shown;
        was.textContent = show ? money(full) : '';
        was.hidden = !show;
      }
      // savings vs buying single sticks; the last tier also carries the "best value" label
      const save = t.querySelector('[data-tier-save]');
      if (save) {
        const diff = full - shown;
        const isLast = t === t.parentElement.lastElementChild;
        const lastTxt = (t.parentElement.dataset.lastFlag || '').trim();
        save.textContent = diff > 0 ? `${isLast && lastTxt ? lastTxt + ' · ' : ''}${fmt(L.save, { amount: money(diff) })} · ${fmt(L.save_pct, { pct: Math.round(diff / full * 100) })}` : (isLast ? lastTxt : '');
        save.hidden = !save.textContent;
      }
      // delivery is free from the 2-month tier (Settings > Shipping, every market)
      const ship = t.querySelector('[data-tier-ship]');
      if (ship) {
        const thr = CFG.freeShipThreshold || 0;
        ship.textContent = !thr ? '' : (shown >= thr ? L.free_delivery : L.plus_delivery);
        ship.classList.toggle('free', !!thr && shown >= thr);
      }
      t.setAttribute('aria-pressed', String(label === v.options[1]));
    });

    const addBtn = $('#addBtn');
    if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? (addBtn.dataset.label || L.add_to_bag) : L.sold_out; }
    $('#satcName') && ($('#satcName').textContent = [v.options[0], v.options[1]].filter(Boolean).join(' · '));
    $('#satcMeta') && ($('#satcMeta').textContent = v.available ? L.in_stock : L.sold_out);
    $('#satcPrice') && ($('#satcPrice').textContent = money(useSub && alloc ? alloc.price : v.price));
  }

  $$('#shades .sw').forEach(b => b.addEventListener('click', () => {
    $$('#shades .sw').forEach(x => x.setAttribute('aria-pressed', 'false'));
    b.setAttribute('aria-pressed', 'true'); paint();
  }));
  $$('#tiers .tier').forEach(t => t.addEventListener('click', () => {
    $$('#tiers .tier').forEach(x => x.setAttribute('aria-pressed', 'false'));
    t.setAttribute('aria-pressed', 'true'); paint();
  }));

  async function addToCart(e) {
    e?.preventDefault();
    const v = current(); if (!v) return;
    const body = { items: [{ id: v.id, quantity: 1 }] };
    const planEl = $('#sellingPlan');
    if (planEl && planEl.value) body.items[0].selling_plan = +planEl.value;
    const btn = $('#addBtn'); const label = btn?.textContent;
    if (btn) { btn.disabled = true; btn.textContent = L.adding; }
    try {
      const r = await fetch(CFG.routes.add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      if (!r.ok) throw new Error((await r.json()).description || L.add_error);
      await renderCart(); openDrawer('cart');
    } catch (err) {
      if (btn) btn.textContent = err.message.slice(0, 40);
      setTimeout(() => { if (btn) btn.textContent = label; }, 2500);
    } finally { if (btn) { btn.disabled = false; setTimeout(() => { btn.textContent = label; }, 0); } }
  }
  form.addEventListener('submit', addToCart);
  on('#satcBtn', 'click', addToCart);

  on('#tSub', 'click', () => { $('#tSub').setAttribute('aria-pressed','true'); $('#tOne').setAttribute('aria-pressed','false'); paint(); });
  on('#tOne', 'click', () => { $('#tOne').setAttribute('aria-pressed','true'); $('#tSub').setAttribute('aria-pressed','false'); paint(); });

  paint();
  if ($('#satc') && $('#addBtn'))
    new IntersectionObserver(([e]) => $('#satc').classList.toggle('on', !e.isIntersecting), { threshold: 0 }).observe($('#addBtn'));
}

/* ---------- cart drawer ---------- */
const packN = label => { const n = parseInt(label, 10); return Number.isFinite(n) && n > 0 ? n : 1; };
const prodCache = {};
/* what this line would cost as single sticks (1-month price x pack x qty); falls back to the line's own price */
async function wasPrice(l) {
  const plain = l.original_line_price;
  try {
    const prefix = (CFG.routes.cart || '').replace(/\/cart$/, '');
    const prod = await (prodCache[l.handle] || (prodCache[l.handle] = fetch(prefix + '/products/' + l.handle + '.js').then(r => r.json())));
    const cv = prod.variants.find(x => x.id === l.variant_id);
    if (cv && cv.compare_at_price > cv.price) return Math.max(plain, cv.compare_at_price * l.quantity);
    if (l.selling_plan_allocation) return plain;
    const opts = (l.options_with_values || []).map(o => o.value);
    const pack = packN(opts[1]);
    const base = prod.variants.find(v => v.option1 === opts[0] && packN(v.option2) === 1);
    if (!base || pack < 2) return plain;
    return Math.max(plain, base.price * pack * l.quantity);
  } catch (e) { return plain; }
}
async function renderCart() {
  const body = $('#cartBody'), foot = $('#cartFoot'), count = $('#cartCount');
  if (!body) return;
  let cart;
  try { cart = await (await fetch(CFG.routes.cart + '.js')).json(); } catch (e) { return; }

  count && (count.hidden = !cart.item_count, count.textContent = cart.item_count);
  $('#cartHdCount') && ($('#cartHdCount').textContent = cart.item_count ? fmt(cart.item_count === 1 ? L.items_one : L.items_other, { count: cart.item_count }) : '');

  if (!cart.item_count) {
    body.innerHTML = `<div class="cart-empty"><b>${L.empty_title}</b><p>${L.empty_body}</p></div>`;
    $('#cartSave') && ($('#cartSave').innerHTML = ''); foot.hidden = true; return;
  }

  const tick = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 8.5l3 3L13 5"/></svg>';
  const van = '<svg viewBox="0 0 20 16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M1 3h11v9H1zM12 6h4l3 3v3h-7z"/><circle cx="5" cy="13" r="1.6"/><circle cx="15" cy="13" r="1.6"/></svg>';
  const thr = CFG.freeShipThreshold || 0;
  const toFree = Math.max(0, thr - cart.total_price);
  // Every Big-5 market ships free on a carrier-named rate, so there is no bar to
  // fill — name the carrier instead. Falls back to the old threshold bar if a
  // threshold is ever reintroduced in Settings > Shipping.
  const carrierLine = fmt(L.unlocked, { carrier: CFG.carrier || L.tracked });
  const shipBar = CFG.freeShipping
    ? `<div class="ship-bar done"><p class="lab">${tick}${carrierLine}</p><div class="track"><div class="fill" style="width:100%"></div></div></div>`
    : !thr ? '' : toFree === 0
    ? `<div class="ship-bar done"><p class="lab">${tick}${fmt(L.unlocked, { carrier: CFG.carrier || L.tracked })}</p><div class="track"><div class="fill" style="width:100%"></div></div></div>`
    : `<div class="ship-bar"><p class="lab">${van}${fmt(L.away, { amount: money(toFree), carrier: CFG.carrier || '' }).replace(/\s{2,}/g, ' ')}</p><div class="track"><div class="fill" style="width:${Math.min(100, cart.total_price / thr * 100).toFixed(0)}%"></div></div></div>`;

  const was = await Promise.all(cart.items.map(wasPrice));
  body.innerHTML = shipBar + cart.items.map((l, i) => `
    <div class="ci">
      <span class="ci-th">${l.image ? `<img src="${l.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2')}" alt="" loading="lazy">` : ''}</span>
      <div><b>${l.product_title}</b><span class="sub">${[l.variant_title, l.selling_plan_allocation?.selling_plan?.name].filter(Boolean).join(' · ') || ''}</span>
        <button type="button" class="rm" data-line="${i + 1}">${L.remove}</button></div>
      <span class="amt">${money(l.final_line_price)}${was[i] > l.final_line_price ? `<s>${money(was[i])}</s>` : ''}</span>
    </div>`).join('');

  $$('[data-line]').forEach(b => b.addEventListener('click', async () => {
    await fetch(CFG.routes.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: +b.dataset.line, quantity: 0 }) });
    renderCart();
  }));

  const saved = Math.max(was.reduce((a, b) => a + b, 0) - cart.total_price, cart.original_total_price - cart.total_price);
  $('#cartSave') && ($('#cartSave').innerHTML = saved > 0
    ? `${tick}${fmt(L.saving, { amount: money(saved) })}` : '');
  $('#cSub').textContent = money(cart.items_subtotal_price);
  const shipFree = CFG.freeShipping || (toFree === 0 && !!thr);
  $('#cShip').textContent = shipFree ? L.free : L.at_checkout;
  $('#cartShipRow')?.classList.toggle('free', shipFree);
  $('#cTot').textContent = money(cart.total_price);
  foot.hidden = false;
}
renderCart();

/* ---------- reveal ---------- */
const io = new IntersectionObserver((es, obs) => es.forEach(e => {
  if (!e.isIntersecting) return; e.target.classList.add('in'); obs.unobserve(e.target);
}), { threshold: .2 });
$$('.sec-hd, .weeks, .how, .rv-grid, .home-shades, .guar, .tbl-scroll').forEach(el => { el.classList.add('up'); io.observe(el); });
})();
